<div class="view-status-wrapper">
  <div class="view-status-wrapper__header">
    <div class="view-status-wrapper__header-left">
      <span class="view-status-wrapper__header--title">{{ headingName }}</span>
      <span class="view-status-wrapper__header--subtitle">{{ subtitle }}</span>
    </div>
    <span class="view-status-wrapper__header--value">{{ getTitle() }}</span>
  </div>

  @if (workshop) {
    <section class="view-status-panel">
      <div class="view-status-panel__top">
        <div class="view-status-panel__schedule">
          <span class="view-status-panel__label">Workshop</span>
          <div class="view-status-panel__date-chip">
            <span class="view-status-panel__date-chip--text">
              {{ workshopRes?.res?.workshopWeek || '--' }}
            </span>
            @if (workshopRes?.res?.remainingDays != null && workshopRes?.res?.workshopWeek) {
              <span class="view-status-panel__date-chip--days">
                {{ workshopRes.res.remainingDays }} days from today
              </span>
            }
          </div>
        </div>
        <span
          class="status-badge"
          [class.status-badge--confirmed]="isConfirmedStatus(workshopRes)"
          [class.status-badge--pending]="!isConfirmedStatus(workshopRes)"
        >
          {{ statusLabel(workshopRes) }}
        </span>
      </div>

      <div class="view-status-row">
        <span class="view-status-row__title">Client Representative Email</span>
        <div class="view-status-row__value">
          {{ workshop.client_representative_email || '--' }}
        </div>
      </div>

      <div class="view-status-row">
        <span class="view-status-row__title">Client Representative Phone No.</span>
        <div class="view-status-row__value">
          {{ workshop.client_representative_phone || '--' }}
        </div>
      </div>

      <div class="view-status-row">
        <span class="view-status-row__title">Attendees</span>
        <div class="view-status-row__attendees">
          <app-meeting-attendees [attendees]="workshop.attendees"></app-meeting-attendees>
        </div>
      </div>

      @if (showActions('workshop')) {
        <div class="view-status-actions">
          @if (!workshopRes.canReschedule) {
            <button type="button" class="btn-ghost" (click)="onCancelRequest('cancel')">
              Cancel
            </button>
          }
          @if (workshopRes.canReschedule) {
            <button
              type="button"
              class="btn-primary"
              (click)="onClickProposedStatusRequest('workshop')"
            >
              Reschedule
            </button>
          }
          <button
            type="button"
            class="btn-primary"
            (click)="onClickScheduleRequest('workshop')"
          >
            {{ workshopRes.txtActionButton }}
          </button>
        </div>
      }
    </section>
  }

  @if (workshop && siteVisit) {
    <hr class="view-status-divider" />
  }

  @if (siteVisit) {
    <section class="view-status-panel">
      <div class="view-status-panel__top">
        <div class="view-status-panel__schedule">
          <span class="view-status-panel__label">Site Visit</span>
          <div class="view-status-panel__date-chip">
            <span class="view-status-panel__date-chip--text">
              {{ siteVisitRes?.res?.workshopWeek || '--' }}
            </span>
            @if (siteVisitRes?.res?.remainingDays != null && siteVisitRes?.res?.workshopWeek) {
              <span class="view-status-panel__date-chip--days">
                {{ siteVisitRes.res.remainingDays }} days from today
              </span>
            }
          </div>
        </div>
        <span
          class="status-badge"
          [class.status-badge--confirmed]="isConfirmedStatus(siteVisitRes)"
          [class.status-badge--pending]="!isConfirmedStatus(siteVisitRes)"
        >
          {{ statusLabel(siteVisitRes) }}
        </span>
      </div>

      <div class="view-status-row">
        <span class="view-status-row__title">Client Representative Email</span>
        <div class="view-status-row__value">
          {{ siteVisit.client_representative_email || '--' }}
        </div>
      </div>

      <div class="view-status-row">
        <span class="view-status-row__title">Client Representative Phone No.</span>
        <div class="view-status-row__value">
          {{ siteVisit.client_representative_phone || '--' }}
        </div>
      </div>

      @if (showActions('siteVisit')) {
        <div class="view-status-actions">
          @if (!siteVisitRes.canReschedule) {
            <button type="button" class="btn-ghost" (click)="onCancelRequest('cancel')">
              Cancel
            </button>
          }
          @if (siteVisitRes.canReschedule) {
            <button
              type="button"
              class="btn-primary"
              (click)="onClickProposedStatusRequest('siteVisit')"
            >
              Reschedule
            </button>
          }
          <button
            type="button"
            class="btn-primary"
            (click)="onClickScheduleRequest('siteVisit')"
          >
            {{ siteVisitRes.txtActionButton }}
          </button>
        </div>
      }
    </section>
  }

  @if (viewOnly) {
    <div class="view-status-actions view-status-actions--close">
      <button type="button" class="btn-primary" (click)="onClose()">Close</button>
    </div>
  }
</div>
